export const Status = {
  Accepted: "Accepted",
  Expiring: "Expiring",
  ExpiringReplaced: "ExpiringReplaced",
  New: "New",
  OfferDeclined: "OfferDeclined",
  Offered: "Offered",
  RequestDeclined: "RequestDeclined",
  Requested: "Requested",
  Scheduled: "Scheduled",
  Suspended: "Suspended",
  SuspendedReplaced: "SuspendedReplaced",
};

export const currencies = {
  AUD: "AU$",
  CAD: "CAN$",
  CNY: "CN¥",
  EUR: "€",
  NZD: "NZ$",
  SGD: "S$",
  USD: "US$",
};

/* tslint:disable:object-literal-sort-keys */
export const AddressTypeIds = {
  Headquarters: 1,
  Billing: 2,
};

export const SubscriptionStatusIds = {
  Requested: 1,
  Denied: 2,
  Approved: 3,
  Active: 4,
  Cancelling: 5,
  Cancelled: 6,
  Suspended: 7,
};

export enum DataSharingTypeEnum {
  None = 0,
  SharingAgreements = 1, // aka digital handshake
  SharingRules = 2 // legacy
}

/* tslint:enable:object-literal-sort-keys */

export const EnvironmentIds = {
  Sandbox: 1,
  Live: 2,
}

const AssetIds = {
  CPu: "00000000-0000-0001-0000-000000000037",
  TerminalVisits: "00000000-0000-0001-0000-000000000041",
  EdifactToXml: "00000000-0000-0001-0000-000000000050",
}

export const NotificationSystem2AssetIds = [
  AssetIds.CPu,
  AssetIds.TerminalVisits,
  AssetIds.EdifactToXml
]




// WEBPACK FOOTER //
// ./src/modules/shared/constants/index.ts